import React from 'react';
import { Link } from 'react-router-dom';
import { Plug, ArrowRight } from 'lucide-react';
import ClioDirectoryBadge from '../../components/ClioDirectoryBadge';

const ClioIntegration = () => {
  return (
    <section id="clio" className="my-20">
      <div className="text-center mb-10">
        <div className="inline-block mb-4">
          <div className="flex items-center justify-center px-4 py-1.5 rounded-full bg-sortio-primary/10 border border-sortio-primary/20">
            <Plug className="mr-2 text-sortio-primary" size={14} />
            <span className="text-xs font-medium uppercase tracking-wider text-sortio-primary">
              Available now: Clio Manage integration
            </span>
          </div>
        </div>
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          Built for Clio
        </h2>
        <ClioDirectoryBadge />
      </div>

      <div className="bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-8 sm:p-10 max-w-3xl mx-auto space-y-4">
        <p className="text-apple-200 text-base sm:text-lg leading-relaxed">
          Sortio integrates directly with Clio Manage via the official API. Connect your account on
          the Integrations page, and your full matter list is available for document matching within
          seconds. No middleware. No data migration. No IT setup.
        </p>
        <p className="text-apple-200 text-base sm:text-lg leading-relaxed">
          The matter matcher respects your LLM choice. Switch to Ollama and even the matter party
          names stay on your machine; classification happens locally and only the file upload
          itself crosses to Clio.
        </p>
        <p className="text-apple-200 text-base sm:text-lg leading-relaxed">
          A 200-file intake folder lands in the right matters in under five minutes on a modern
          Mac, with a confidence score on every assignment and an undoable preview before anything
          moves.
        </p>
        <div className="pt-4 flex flex-wrap gap-x-6 gap-y-2">
          <Link
            to="/for-law-firms"
            className="inline-flex items-center text-sortio-primary hover:text-sortio-secondary transition-colors text-sm font-medium"
          >
            See the full Clio workflow for firms <ArrowRight className="ml-1.5" size={14} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ClioIntegration;
